export default __webpack_public_path__ + "static/media/join-league-gr.c28bea04.png";